import Wrapper from "./Wrapper";
import DesktopWrapper from "./DesktopWrapper";

export default Wrapper;
export {
    DesktopWrapper
}